
export interface FileUpload {
  id: string;
  user_id: string;
  file_name: string;
  file_size: number;
  file_type: string;
  storage_path: string;
  upload_status: 'pending' | 'processing' | 'completed' | 'failed';
  data_type: 'balance_sheet' | 'income_statement' | 'cash_flow' | 'general';
  imported_records_count: number;
  error_message?: string;
  created_at: string;
  updated_at: string;
}

export const ALLOWED_FILE_TYPES = {
  'text/csv': ['.csv'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
} as const;

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
